/* ------------------------------------*\
    #FORM SECTION SCRIPT
\*------------------------------------ */

import PanelGroup from '../../../../../src/js/components/panelgroup';

class FormSection extends PanelGroup {

    static componentName = 'form-section';

    static componentSelector = '.js-form-section';

    static defaultOptions = PanelGroup.extendDefaultOptions({
        btnSelector: '.js-form-section__header',
        panelSelector: '.js-form-section__panel',
        btnAction: 'toggle',
        parentToggleClass: 'is-open',
    });

    constructor() {
        super(...arguments);

        /**
         * Add state class initially.
         */
        this.$$panels.forEach((panel) => {
            if (panel?.matches('[aria-hidden="true"]')) {
                panel?.classList.add('is-collapsed');
            } else if (panel?.matches('[aria-hidden="false"]')) {
                panel?.classList.add('is-expanded');
            }
        });

        /**
         * When transition has ended.
         */
        this.$$panels.on('transitionend', ({ target }) => {
            /**
             * Prevent any actions on non-panels.
             */
            if (!target?.classList.contains('js-form-section__panel')) {
                return;
            }

            /**
             * Add class when transition has finished as trigger that can
             * be used in CSS.
             */
            if (target.matches('[aria-hidden="true"]')) {
                target.classList.add('is-collapsed');
            } else if (target.matches('[aria-hidden="false"]')) {
                target.classList.add('is-expanded');
            }
        });

        /**
         * When transition has started.
         */
        this.$$panels.on('transitionstart', ({ target }) => {
            /**
             * Prevent any actions on non-panels.
             */
            if (!target?.classList.contains('js-form-section__panel')) {
                return;
            }

            if (target.matches('[aria-hidden="true"]')) {
                target.classList.remove('is-expanded');
            } else if (target.matches('[aria-hidden="false"]')) {
                target.classList.remove('is-collapsed');
            }
        });
    }

}

FormSection.register();

export default FormSection;
